import React from "react";
import { Redirect } from "react-router-dom";
import { Paths } from "../../constants/UrlConstants";

export function Demo() {
  return <Redirect to={Paths.NotFound} />;
}

export default Demo;
